/** Tab options for the preorders table. */
const PREORDERS_TABLE_TAB = {
    ALL: 'all',
    PENDING_INVITATION: 'pending_invitation',
    AWAITING_CHECKOUT: 'awaiting_checkout',
    IDLE: 'idle',
    CONVERTED: 'converted',
    CANCELED: 'canceled',
};

export { PREORDERS_TABLE_TAB };
//# sourceMappingURL=PreordersTableTab.js.map
